import { Button, Dialog, Group, Pane, Text, TextInput, toaster } from "evergreen-ui";
import { useState } from "react";
import Request from "../../../../util/Api";

const TransferModal = (props) => {

    const defaultFrom = 1;
    const defaultTo = 4;

    const [ selectedFrom, setSelectedFrom ] = useState(defaultFrom);
    const [ selectedTo, setSelectedTo ] = useState(defaultTo);
    const [ amount, setAmount ] = useState(1);

    const transferStock = async () => {
        try {
            await Request.post(`/inventory/transfer`, {}, {}, {
                source: selectedFrom,
                target: selectedTo,
                quantity: amount,
                productId: props.product.id
            });

            toaster.success('Transfer efectuat cu succes!');
            props.onUpdate();

        } catch (e) {
            toaster.danger(e.message);
        }


    }

    const selectAccount = (id, type) => {
        if(type === 'from') {
            if(selectedTo === id) {
                setSelectedTo(selectedFrom)
            }
            setSelectedFrom(id);

        } else {
            if(selectedFrom === id) {
                setSelectedFrom(selectedTo)
            }
            setSelectedTo(id);
        }
    }

    return <Dialog
            shouldCloseOnOverlayClick={false}
            isShown={props.open}
            title= {"Transfer Gestiuni"}
            hasFooter={false}
            width={800}
            onCloseComplete={props.onClose}
            onClose={props.onClose}>
                <Pane display="flex" flexDirection="row" gap={40} justifyContent="space-between">
                    <Pane display="flex" justifyContent="flex-start" flexDirection="column">
                        <TextInput
                            placeholder="Enter amount"
                            type="number"
                            min={1}
                            value={amount}
                            onChange={e => setAmount(e.target.value)}
                        />
                        <Button appearance="primary" intent="success" marginTop={16} onClick={() => { transferStock();}}>
                            Transfer
                        </Button>
                    </Pane>
                    <Pane>
                        <Pane>
                            <Group spacing={8} marginBottom={16}>
                                <Text marginRight={8}>Din</Text>
                                {props.stockAccounts.map(account => (
                                    <Button key={account.name} isActive={selectedFrom === account.id} onClick={() => selectAccount(account.id, 'from')}>
                                        {account.name}
                                        {props.product.quantities.find(qty => qty.stockAccountId === account.id) ?
                                        ` ${props.product.quantities.find(qty => qty.stockAccountId === account.id).quantity}` : ' 0'}

                                        {(props.outstanding || []).find(qty => qty.stockAccountId === account.id) ?
                                        ` (${props.outstanding.find(qty => qty.stockAccountId === account.id).quantity})` : ''}
                                    </Button>
                                ))}
                            </Group>

                            <Group spacing={8} marginBottom={16}>
                                <Text marginRight={8}>Spre</Text>
                                {props.stockAccounts.map(account => (
                                    <Button key={account.name} isActive={selectedTo === account.id} onClick={() => selectAccount(account.id, 'to')}>
                                        {account.name}
                                         {props.product.quantities.find(qty => qty.stockAccountId === account.id) ?
                                        ` ${props.product.quantities.find(qty => qty.stockAccountId === account.id).quantity}` : ' 0'}

                                        {(props.outstanding || []).find(qty => qty.stockAccountId === account.id) ?
                                        ` (${props.outstanding.find(qty => qty.stockAccountId === account.id).quantity})` : ''}
                                    </Button>
                                ))}
                            </Group>
                        </Pane>
                    </Pane>
                </Pane>
            </Dialog>
}

export default TransferModal;
